import { Card, Grid, Flex, Text, Box, Progress, ScrollArea } from '@radix-ui/themes';
import CircleProgress from '../../shared/CircleProgress';

const CoursePerformance = ({ planStats, onSelect, selected = null }) => {
    return (
        <Card>
            <ScrollArea scrollbars="horizontal" style={{ maxHeight: '300px', width: '100%' }}>
                <Grid>
                    <Flex direction="row" gap="3" wrap="nowrap" align="center" justify="start" mb="4">
                        {planStats.map((plan, index) => (
                            <Flex key={plan.id} direction="row" align="center" justify="between" gap="2" mb="4" p="2" minWidth="200px"
                                style={{
                                    border: 'solid thin',
                                    borderColor: (selected && selected.type == 'course' && selected.id == plan.course_id) ? 'var(--accent-9)' : 'var(--gray-4)',
                                    cursor: 'pointer', borderRadius: 10
                                }}
                                onClick={() => onSelect?.({ type: 'course', id: plan.course_id })}
                            >
                                <Box>
                                    <Text size="1" color="gray">{plan.course_name}</Text>
                                    <Progress value={plan.completion_rate} color="var(--accent-9)" style={{ maxWidth: '100px' }} />
                                </Box>
                                <CircleProgress
                                    progress={Number(plan.average_score)}
                                    size={40}
                                    strokeWidth={3}
                                    color="var(--accent-9)"
                                    label={Math.floor(plan.average_score)}
                                    labelSize="1"
                                />
                            </Flex>
                        ))}
                    </Flex>
                </Grid>
            </ScrollArea>
        </Card>
    );
};

export default CoursePerformance;